export default __webpack_public_path__ + "static/media/abouteme.e9593c9d.png";